/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .react-flow {
    --color-primary: rgb(19, 117, 237);
    --xy-background-color: #f7f9fb;
    /* Custom Variables */
    --xy-theme-hover: #c5c5c5;
    --xy-theme-edge-hover: black;
    --xy-theme-color-focus: #e8e8e8;

    --xy-node-border-default: 1px solid #ededed;

    --xy-node-boxshadow-default: 0px 3.54px 4.55px 0px #00000005, 0px 3.54px 4.55px 0px #0000000d, 0px 0.51px 1.01px 0px #0000001a;

    --xy-node-border-radius-default: 8px;

    --xy-handle-background-color-default: #ffffff;
    --xy-handle-border-color-default: #aaaaaa;

    --xy-edge-label-color-default: #505050;
  }

  .xy-theme__button,
  .xy-theme__button-group > * {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 1.7rem;
    padding: 0 0.5rem;
    border-radius: 100px;
    border: 1px solid var(--color-primary);
    background-color: white;
    color: var(--color-primary);
    &:active,
    &.is-active {
      color: white;
      background-color: var(--color-primary);
    }
    transition: background-color 0.2s ease, border-color 0.2s ease;
    box-shadow: var(--xy-node-boxshadow-default);
    cursor: pointer;
    font-size: 10pt;

    &.fade-to-color {
      transition: border-color background-color color 0.2s ease;
      &:active,
      &.is-active {
        &,
        &:hover {
          color: white;
          background-color: var(--fade-color);
        }
      }
      &:hover {
        border-color: var(--fade-color);
        color: var(--fade-color);
      }
    }
  }

  .xy-theme__button-group {
    display: inline-block;
    > *:has(+ *) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    > * + * {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      margin-left: 0;
    }
    > .xy-theme__button + .xy-theme__button {
      margin-left: 0;
    }
  }

  .xy-theme__button,
  .xy-theme__button-group {
    + .xy-theme__button,
    + .xy-theme__button-group {
      margin-left: 0.3rem;
    }
  }

  .react-flow__edge-textbg {
    fill: var(--xy-background-color);
  }

  .react-flow__edge.selectable:hover .react-flow__edge-path {
    stroke-width: 2px;
  }

  .react-flow__handle.connectionindicator:hover {
    pointer-events: all;
    border-color: var(--xy-theme-edge-hover);
    background-color: gray;
    width: 15px;
    height: 15px;
  }

  .react-flow__handle {
    width: 9px;
    height: 9px;
  }

  .react-flow__node-step:has(> .desicion-node-container) {
    height: fit-content !important;
    width: fit-content !important;
  }

  .react-flow__minimap-node {
    &.selected {
      fill: rgb(164, 189, 219);
    }

    &.branch {
      transform-box: fill-box;
      transform-origin: center;
      transform: rotate(45deg);
    }

    &.end {
      rx: 100%;
      ry: 100%;
    }
  }

  .react-flow__node.selectable:hover,
  .react-flow__node.draggable:hover {
    > .basic-node {
      outline: 1px solid gray;
    }
  }

  .react-flow__node.selectable,
  .react-flow__node.draggable {
    > .decision-node-container > .decision-node:hover {
      outline: 1px solid gray;
    }
  }

  .react-flow__node-toolbar {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .workflow-object-selector-dropdown {
    display: flex;
    justify-content: center;
    position: relative;
    border: none !important;
  }

  .workflow-param-panel {
    max-width: 500px;
  }

  .role-form-container.horizontal {
    display: grid;
    grid-template-columns: 300px 1fr;
    gap: 16px;
    min-height: 0;

    > .table-container {
      max-height: 100%;
      overflow: auto;
      min-height: 0;
    }
  }

  .workflow-sidebar-buttons {
    > .btn-group {
      > .btn {
        outline: none !important;
        box-shadow: none !important;
      }
    }
  }

  .note-node-textarea {
    background: transparent;
    border: transparent;
  }
`;
